import { render, staticRenderFns } from "./bank_book.vue?vue&type=template&id=57757aaa&"
import script from "./bank_book.vue?vue&type=script&lang=js&"
export * from "./bank_book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports